import Immutable from 'immutable';
import { UPDATE_STATISTICS, UPDATE_STATISTICS_DATALAKE_VIEW } from '../actions/statistics';

const STATISTICS = 'statistics';

export default function statistics(state = Immutable.Map(), action) {
    switch (action.type) {
        case UPDATE_STATISTICS:
            return state.setIn([], Immutable.fromJS(action.payload));
        case UPDATE_STATISTICS_DATALAKE_VIEW:
            return state.setIn(['dataLake'], Immutable.fromJS(action.payload.dataLake));
        default:
            return state;
    }
}

export const statisticsSelector = (state) => state.getIn([STATISTICS]);
